import req from '@/utils/request';

// 关键词新增
export const addKeyword = (params) => {
    return req.post('/wechat/keyword/receive', params);
}

// 关键词修改
export const editKeyword = (params) => {
    return req.put('/wechat/keyword/receive', params);
}

// 关键词删除
export const delKeyword = (params) => {
    return req.delete('/wechat/keyword/receive', params);
}

// 分页查询关键词
export const getPage = (params) => {
    return req.get('/wechat/keyword/receive/page', params);
}

// 查询关键词详情
export const getDetail = (params) => {
    return req.get('/wechat/keyword/receive/detail', params);
}
//公众号欢迎语设置
export const saveGreeting = (params) => {
    return req.post('/wechat/greeting', params);
}
//查询公众号欢迎语设置
export const getGreeting = (params) => {
    return req.get('/wechat/greeting', params);
}

